export default __webpack_public_path__ + "static/media/stories.6e2e66ce.png";